import { useRef, useState } from "react";
import GenericInput from "../../../../../common/GenericInput";
import Modal from "@mui/material/Modal";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store";
import useDataFetch, {
  DataFetchOptionsType,
} from "../../../../../hooks/useDataFetch";
import { fetchTagsAPIresponse } from "../../../services";
import { STATIC_STRINGS } from "../../../../../utils/Constants";
import { updateSkills } from "../../../../../store/steps/stepOneSlice";
import GenericAutocomplete from "../../../../../common/GenericAutocomplete";
import { SIZES } from "../../../../../utils/enums";
import GenericToast from "../../../../../common/GenericToast";

const AskAiModal = ({ open, setOpen }) => {
  const [aiQuery, setAiQuery] = useState<string>("");
  const [fetchedTags, setFetchedTags] = useState<string[]>([]);
  const handleClose = () => setOpen(false);
  const dispatch = useDispatch();
  const skills = useSelector((state: RootState) => state.stepOne.skills);
  const autocompleteRef = useRef<HTMLInputElement>(null);

  const [fetchOptions, setFetchOptions] = useState<DataFetchOptionsType>({});
  const { data, error } = useDataFetch(fetchTagsAPIresponse, fetchOptions);

  const [isToastOpen, setToastOpen] = useState(false);
  const fetchTags = async () => {
    if (!aiQuery.trim()) {
      setToastOpen(true);
      return;
    }
    setFetchedTags(data || []);
    autocompleteRef.current?.focus();
  };
  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <div className="border-2 border-neutral-dark h-1/3 w-1/2 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-md bg-white absolute flex flex-col justify-around items-center">
          <div className="px-4 flex items-center justify-around w-full">
            <GenericInput
              type="text"
              value={aiQuery}
              onChange={(e) => {
                setAiQuery(e.target.value);
              }}
              placeholder={STATIC_STRINGS.ASK_AI_PLACEHOLDER}
              className="w-4/5"
            />
            <button onClick={fetchTags} className="btn btn-primary">
              {STATIC_STRINGS.ASK_AI}
            </button>
          </div>
          <div className="w-[90%] mx-auto">
            <GenericAutocomplete
              ref={autocompleteRef}
              disableCloseOnSelect={true}
              openOnFocus={true}
              size={SIZES.sm}
              options={fetchedTags}
              value={skills}
              onChangeHandler={(event, newValue) =>
                dispatch(updateSkills([...newValue]))
              }
              placeholder={STATIC_STRINGS.SKILLS_PLACEHOLDER}
            />
          </div>
        </div>
      </Modal>
      <GenericToast
        label={"Please enter a valid query!"}
        onCloseHandler={() => setToastOpen(false)}
        open={isToastOpen}
      />
    </>
  );
};
export default AskAiModal;
